import $ from 'jquery';

$(function () {
  if ($('.additional_question').length) {
    var $addOptionButton = $('.js-add-option-button');
    var minOptions = $('.js-selectable-options-count').data('min');

    var $updatePreviewButton = $('.js-update-question-preview');
    var updatePreview, getQueryObject, buildPreviewUrl, questionType;

    var showOrHideRemoveButtons = function () {
      if ($('.js-selectable-option:visible').length <= minOptions) {
        $('.js-remove-option').addClass('hidden');
      } else {
        $('.js-remove-option').removeClass('hidden');
      }
    };

    var showOrHideAddButton = function () {
      if (!$('.js-selectable-option:hidden').length) {
        $addOptionButton.addClass('hidden');
      }
    };

    $('.js-add-option-button').click(function () {
      var $hiddenOption = $('.js-selectable-option.hidden').first();
      $hiddenOption.removeClass('hidden');
      $hiddenOption.find('input.js-option-text').prop('disabled', false);
      $hiddenOption.find('input.js-option-text').prop('required', true);

      showOrHideRemoveButtons();
      showOrHideAddButton();
    });

    getQueryObject = function ($inputs) {
      var queryObject = {
        stars: 5,
        preview: true,
      };

      var selectableOptions;
      var count = 0;
      $inputs.each(function () {
        if ($(this).hasClass('js-question-preview-option-input')) {
          // build option inputs as array of hashs
          selectableOptions = selectableOptions || [];
          selectableOptions.push({
            text: this.value || this.innerText,
            val: count,
          });
          count = count + 1;
        } else {
          queryObject[this.dataset.emberKeyName] = this.value || this.innerText;
        }
      });

      queryObject['commentEnabled'] = $($inputs)
        .filter('[name$="_question[comment_enabled]"]')
        .prop('checked');

      queryObject.questionType = questionType();
      if (selectableOptions) {
        queryObject.selectableOptions = JSON.stringify(selectableOptions);
      }
      // send array as json so it is easier for browers to parse

      return queryObject;
    };

    buildPreviewUrl = function (baseUrl, $inputs) {
      var url = baseUrl;
      url += '/?';
      url += $.param(getQueryObject($inputs)).replace(/%20/g, '+');
      return url;
    };

    updatePreview = function () {
      var $iframe = $('.js-question-preview-area iframe:visible');
      var baseUrl = $iframe.data('baseUrl');
      var $inputs = $(
        '.js-question-preview-input:visible, .js-question-preview-input#js-question-type-select, select.js-question-preview-input',
      );
      $iframe.attr('src', buildPreviewUrl(baseUrl, $inputs));
    };

    $updatePreviewButton.click(function () {
      updatePreview();
    });

    $('.js-remove-option').click(function () {
      var $option = $(this).parents('.js-selectable-option');
      $option.addClass('hidden');
      $option.find('input.js-option-text').prop('disabled', true);
      $option.find('input.js-option-text').prop('required', false);

      $addOptionButton.removeClass('hidden');
      showOrHideRemoveButtons();
    });

    questionType = function () {
      var val = $('#js-question-type-select').val();
      if (!val) {
        val = $('#js-question-type').text().trim();
      }
      var mapping = {
        NpsQuestion: 'ScalarQuestion',
        FcrQuestion: 'MultipleChoiceQuestion',
      };
      return mapping[val] || val;
    };

    $('.js-question-type .dropdown-menu a').ready(function () {
      $('.js-question-type .dropdown-menu a').click(function () {
        $('[data-type-select-label]').addClass('hidden');
        $("[data-type-select-label='" + this.innerText + "']").removeClass(
          'hidden',
        );

        showOrHideRemoveButtons();
        showOrHideAddButton();

        if (!$('.js-question-preview-area iframe:visible').attr('src')) {
          updatePreview();
        }
      });
    });

    showOrHideRemoveButtons();
    showOrHideAddButton();

    $('input:checkbox[name$="_question[comment_enabled]"]').each(function () {
      var checkbox = $(this);
      var textField = checkbox
        .closest('form')
        .find('textarea[name$="_question[comment_prompt]"]')
        .closest('.form-group');
      var slideDuration = 200;

      function updateTextField() {
        if (checkbox.is(':checked')) {
          textField.slideDown(slideDuration);
        } else {
          textField.slideUp(slideDuration);
        }
      }

      checkbox.on('change.bootstrapSwitch', updateTextField);

      updateTextField();
    });

    updatePreview();
  }
});
